export default "__VITE_ASSET__76362c3d__"